import {
  Container,
} from './styles';

export const PrivacyPolicy = () => {
  return (
    <Container>
      <div className="fl-rich-text">
        <div id="comp-jr4edplv2" className="txtNew" data-packed="true">
          <h1 className="font_6"><span className="color_32">App Privacy</span></h1>
        </div>
        <div id="comp-jr4edplv4" className="txtNew" data-packed="true">
          <p className="font_9"><span className="color_15">Effective date: March 2019</span></p>
          <h3>
            <strong>We take privacy seriously and have a few principles that we follow.</strong>
          </h3>
          <ul className="font_9 color_15">
            <li>
              <span className="color_15">We don’t ask you for personal information unless we truly need it</span>
            </li>
            <li>
              <span className="color_15">We don’t share your personal information with anyone…an exception would be if we add a shopping cart in the future it will be necessary to provide shipping information to the warehouse and courier so that product can be packed and shipped. A shopping cart will also require that we utilize a credit card processor who will require payment information. We do not offer a shopping cart at this time, but it is on the roadmap and we want to be up front by letting you know now.</span>
            </li>
            <li>
              <span className="color_15">No personally identifiable data is ever sold to other companies for any reason.</span>
            </li>
            <li>
              <span className="color_15">We don’t store personal information on our server unless required for the on-going operation of our app.</span>
            </li>
          </ul>
          <p className="font_9">
            <span className="color_15">Color My Life, Inc a Delaware Corporation (referenced as “we”, “us”, “our” or “I” in this document) operates&nbsp;the Color My Life mobile app.&nbsp; It’s our policy to respect your privacy regarding any information we may collect while operating our app. By using our app, you agree to be held to the details outlined here.</span>
          </p>
          <h3>
            <strong>What We Collect</strong>
          </h3>
          <p className="font_9">
            <span className="color_15">
              Our app will request an e-mail address and name only for specific operations.&nbsp; Outlined below are the times when we request your information and why.&nbsp; We try and limit this only to when it’s absolutely required to achieve the operation or when required by the software and services we use.
            </span>
          </p>
          <ul className="font_9 color_15">
            <li>
              <p className="font_9">
                <span className="color_15">When you create an account, an e-mail address is required as part of the signup process.&nbsp; When you signup, you will be sent an e-mail to continue the account creation process. Your real name is optional.</span>
              </p>
            </li>
            <li>
              <p className="font_9">
                <span className="color_15">To the email address used for the account, we will be sent periodic email updates and information. You can unsubscribe from these emails.</span>
              </p>
            </li>
            <li>
              <p className="font_9">
                <span className="color_15">The email address used for the account will be sent notifications for account management purposes; those emails are required as part of maintaining an account with the Color My Life app.</span>
              </p>
            </li>
          </ul>
          <h3>
            <strong>What We Do With App Data</strong>
          </h3>
          <p className="font_9">
            <span className="color_15">We store and retrieve data as required for the app operation.&nbsp; Without the information, the action you are requesting (creating an account, searching for items, etc.), we would not be able to do what you request. The data you enter in the app is also stored on a server so that it is backed up and you can synchronize between devices. We have access to the data so that we can manage the account, but the personally identifiable information is not shared unless it is for software development or data management. We maintain contracts and confidentiality agreements with anyone working on the system and they cannot use your data for anything other than software development or data management. We use the data to manage accounts and to improve the app. For example, if you create an item with a barcode that we don’t have in the barcode database we may verify the data and add it to the barcode database. We reserve the right to share consolidated information that is not personally identifiable, such as which items are being added, wishlist content, etc. We do not share creative work, such as Projects&nbsp;unless you specifically authorize it.</span>
          </p>
          <h3>
            <strong>Where It Is Stored</strong>
          </h3>
          <p className="font_9">
            <span className="color_15">
              The majority of your information is stored on our systems with our hosting provider, Amazon Web Services (AWS).&nbsp; AWS does not access any of your information
            </span>
          </p>
          <h3>
            <strong>3rd Party Services Used</strong>
          </h3>
          <p className="font_9">
            <span className="color_15">
              Emails are sent using services called MailGun and MailChimp. They will store your name and e-mail in order to send you the mail.
            </span>
          </p>
          <p className="font_9">
            <span className="color_15">We use an app development company and database development company, with whom we maintain confidentiality agreements.</span>
          </p>
          <h3>
            <strong>Sharing</strong>
          </h3>
          <p className="font_9">
            <span className="color_15">We do not share any data with any advertising or information networks.&nbsp;We may in the future offer consolidated data that is not personally identifiable to suppliers and distributors to assist them in planning inventory.</span>
          </p>
          <h3>
            <strong>Privacy Policy Changes</strong>
          </h3>
          <p className="font_9">
            <span className="color_15">
              Although most changes are likely to be minor, we may change this Privacy Policy from time to time, and at our sole discretion. &nbsp;We encourage visitors to frequently check this page for any changes to our Privacy Policy. &nbsp;Your continued use of this site after any change in this Privacy Policy will constitute your acceptance of such change.
            </span>
          </p>
          <h3>
            <strong>How to Contact Us</strong>
          </h3>
          <p className="font_9">
            <span className="color_15">
              If you would like to contact us with any questions, please do so by emailing support at&nbsp;support@colormylife.com&nbsp;If you want a copy of your information, or request to be forgotten according to your local law, also please do so by emailing support. Note that if you request to be forgotten, most information will be removed.&nbsp; This may include your account and data. This does not include any data we are obliged to keep for administrative, legal, or security purposes.
            </span>
          </p>
        </div>
      </div>
    </Container>
  );
};
